define("shared/components/shared/post/secondary/publishing-method-setup/auto-publish-setup/enable-instagram/index", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p>{{t "onboarding.side_wiz.general.set_up_auto_publishing.subcopy1_1"}}</p>
  <p>{{t "onboarding.side_wiz.general.set_up_auto_publishing.subcopy1_2"}}</p>
  <ol class="u--p__l__md u--m__tb">
    <li class="u--p__tb__xs u--p__lr__0">
      {{t "onboarding.side_wiz.general.set_up_auto_publishing.step1"}}
      <Shared::Link
        @href="https://help.later.com/hc/en-us/articles/1500000110062-Connect-an-Instagram-Profile-to-a-Facebook-Page-"
        @text={{t "shared_phrases.learn_more"}}
        {{track "clicked-fb-help-onboarding" "click"}}
      />
    </li>
    <li class="u--p__tb__xs u--p__lr__0">
      {{t "onboarding.side_wiz.general.set_up_auto_publishing.step2"}}
      <Shared::Link
        @href="https://www.facebook.com/help/510247025775149?helpref=faq_content"
        @text={{t "onboarding.auto_publishing.check_role"}}
        {{track "clicked-fb-check-role-onboarding" "click"}}
      />
    </li>
    <li class="u--p__tb__xs u--p__lr__0">
      {{t "onboarding.side_wiz.general.set_up_auto_publishing.step3"}}
    </li>
  </ol>
  */
  {
    "id": "jPq4W5D0",
    "block": "[[[10,2],[12],[1,[28,[35,0],[\"onboarding.side_wiz.general.set_up_auto_publishing.subcopy1_1\"],null]],[13],[1,\"\\n\"],[10,2],[12],[1,[28,[35,0],[\"onboarding.side_wiz.general.set_up_auto_publishing.subcopy1_2\"],null]],[13],[1,\"\\n\"],[10,\"ol\"],[14,0,\"u--p__l__md u--m__tb\"],[12],[1,\"\\n  \"],[10,\"li\"],[14,0,\"u--p__tb__xs u--p__lr__0\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"onboarding.side_wiz.general.set_up_auto_publishing.step1\"],null]],[1,\"\\n    \"],[8,[39,1],[[4,[38,2],[\"clicked-fb-help-onboarding\",\"click\"],null]],[[\"@href\",\"@text\"],[\"https://help.later.com/hc/en-us/articles/1500000110062-Connect-an-Instagram-Profile-to-a-Facebook-Page-\",[28,[37,0],[\"shared_phrases.learn_more\"],null]]],null],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"li\"],[14,0,\"u--p__tb__xs u--p__lr__0\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"onboarding.side_wiz.general.set_up_auto_publishing.step2\"],null]],[1,\"\\n    \"],[8,[39,1],[[4,[38,2],[\"clicked-fb-check-role-onboarding\",\"click\"],null]],[[\"@href\",\"@text\"],[\"https://www.facebook.com/help/510247025775149?helpref=faq_content\",[28,[37,0],[\"onboarding.auto_publishing.check_role\"],null]]],null],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"li\"],[14,0,\"u--p__tb__xs u--p__lr__0\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"onboarding.side_wiz.general.set_up_auto_publishing.step3\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"t\",\"shared/link\",\"track\"]]",
    "moduleName": "shared/components/shared/post/secondary/publishing-method-setup/auto-publish-setup/enable-instagram/index.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});